<template>
  <v-app>
    <v-main class="main">

      <!-- Sidebar -->
      <AdminSidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
        @update:drawerOpen="drawerOpen = $event" />

      <v-container fluid class="main-content pa-4">

        <!-- Header -->
        <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar" />

        <v-row dense class="g-2" style="height: 100%; padding: 16px;">

          <!-- top area -->
          <v-col cols="12">

            <!-- LOADING STATE Header skeleton-->
            <div v-if="loading" class="d-flex align-center gap-2 mb-4">

              <!-- Avatar -->
              <v-skeleton-loader type="avatar" size="80" class="mr-2" />

              <!-- Text -->
              <div style="flex:1">
                <v-skeleton-loader type="heading" width="200" class="mb-2" />
                <v-skeleton-loader type="text" width="180" class="mb-2" />
                <v-skeleton-loader type="chip" width="120" />
              </div>

            </div>
            <div v-else class="d-flex align-center gap-2 mb-4">
              <v-avatar size="80" style="margin-right: 10px;">
                <img
                  :src="partner?.partner_image ? `${STORAGE_URL}/${partner?.partner_image}` : defaultImage"
                  class="product-image" />
              </v-avatar>
              <div class="text-left">
                <div class="font-weight-bold text-body-1">
                  <h3>{{ partner?.name }}</h3>
                </div>
                <div class="text-caption text-grey">
                  <h4>Active Since {{ formatDateTime(partner?.created_at) }}</h4>
                </div>
              </div>
            </div>

            <!--Loading effect-->
            <div v-if="loading" class="pa-6">

              <!-- Main layout -->
              <v-row dense>

                <!-- LEFT COLUMN -->
                <v-col cols="12" md="12">
                  <v-card class="pa-10" rounded="lg">

                    <v-skeleton-loader type="heading" width="40%" class="mb-6" />

                    <!-- Rows -->
                    <div v-for="n in 6" :key="n" class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <v-skeleton-loader type="text" width="80" />
                        <v-skeleton-loader type="text" width="120" />
                      </div>
                      <v-divider class="mt-3" />
                    </div>

                  </v-card>
                </v-col>
              </v-row>

            </div>

            <!-- Actual content -->
            <div v-else>
              <!-- INNER ROW (THIS FIXES YOUR ISSUE) -->
              <v-row dense>
                <!-- LEFT COLUMN -->
                <!-- <v-col cols="12" md="4" class="d-flex flex-column"> -->

                  <!-- TOP CARD -->
                  <!-- <v-card class="inner-mini-card mb-3 flex-grow-1" flat>
                    <div class="pa-10">
                      <div class="text-small mt-2">
                        <v-avatar size="120">
                          <img :src="partner.partner_image ? `${STORAGE_URL}/${partner.partner_image}` : defaultImage" />
                        </v-avatar>
                      </div>
                    </div>
                  </v-card> -->

                <!-- </v-col> -->

                <!-- RIGHT COLUMN -->
                <v-col cols="12" md="12" class="d-flex">

                  <v-card class="inner-card flex-grow-1" flat>
                    <div class="pa-10">
                      <div class="text-subtitle-1 font-weight-medium">
                        <div class="column-title mb-6">
                          <h5 class="m-0 text-left text-grey">Details</h5>
                        </div>
                      </div>
                      <div class="text-small mt-2">
                        
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-2">
                          <span>Email</span>
                          <span>{{ partner?.email }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-2">
                          <span>Phone</span>
                          <span>{{ partner?.phone }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-2">
                          <span>Partner type</span>
                          <span>{{ capitalize(partner?.partner_type) }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-2">
                          <span>Website</span>
                          <span>{{ partner?.website }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-2">
                          <span>About</span>
                          <span>{{ partner?.about }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-2">
                          <span>Address</span>
                          <span>{{ partner?.address }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-2">
                          <span>Updated On</span>
                          <span>{{ formatDateTime(partner?.updated_at) }}</span>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-col>

              </v-row>
            </div>
          </v-col>

         
        </v-row>
        <!-- ADD / EDIT PARTNER DIALOG -->
<v-dialog v-model="partnerDialog" max-width="700">
  <v-card class="pa-6 rounded-xl">

    <!-- Title -->
    <div class="d-flex justify-space-between align-center mb-6">
      <div class="text-h6 font-weight-bold">
        {{ isEditing ? "Update Partner" : "Add New Partner" }}
      </div>

      <v-btn
        icon
        variant="text"
        @click="partnerDialog = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <!-- FORM -->
    <form @submit.prevent="handleCreatePartner">

      <v-row dense>

        <!-- Name -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="partnerForm.name"
            label="Partner Name"
            variant="outlined"
            :rules="[v => !!v || 'Name is required']"
          />
        </v-col>

        <!-- Email -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="partnerForm.email"
            label="Email"
            type="email"
            variant="outlined"
            :rules="[v => !!v || 'Email is required']"
          />
        </v-col>

        <!-- Phone -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="partnerForm.phone"
            label="Phone Number"
            variant="outlined"
          />
        </v-col>

        <!-- Type -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="partnerForm.partner_type"
            label="Partner Type"
            variant="outlined"
            placeholder=""
          />
        </v-col>

        <!-- Website -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="partnerForm.website"
            label="Website"
            variant="outlined"
          />
        </v-col>

         <!-- About -->
        <v-col cols="12">
          <v-textarea
            v-model="partnerForm.about"
            label="About"
            variant="outlined"
            rows="3"
          />
        </v-col>

        <!-- Address -->
        <v-col cols="12">
          <v-textarea
            v-model="partnerForm.address"
            label="Address"
            variant="outlined"
            rows="2"
          />
        </v-col>

        <!-- Partner Logo -->
        <v-col cols="12">
          <v-file-input
            v-model="partnerForm.logo"
            label="Partner Logo"
            variant="outlined"
            prepend-icon="mdi-camera"
            accept="image/*"
          />
        </v-col>

        <!-- Existing Image -->
        <v-col cols="12" v-if="existingImage">
          <div class="text-caption mb-2">
            Current Logo
          </div>

          <img
            :src="`${STORAGE_URL}/${existingImage}`"
            class="rounded-lg"
            style="width: 120px; height: 120px; object-fit: cover;"
          />
        </v-col>

      </v-row>

      <!-- ACTIONS -->
      <div class="d-flex justify-end mt-6 ga-3">

        <v-btn
          variant="outlined"
          @click="partnerDialog = false"
        >
          Cancel
        </v-btn>

        <v-btn
          color="black"
          type="submit"
          :loading="partnerLoading"
          :disabled="!isPartnerFormValid"
        >
          {{ isEditing ? "Update Partner" : "Save Partner" }}
        </v-btn>

      </div>

    </form>

  </v-card>
</v-dialog>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue"
import AdminSidebar from "@/components/AdminSidebar.vue"
import Header from "@/components/Header.vue"
import { partnerStore } from "@/store/partner"
import { STORAGE_URL } from "@/api/http"
import { useRoute } from "vue-router"
import avatarImage from '@/assets/icon.png'
import {capitalize, formatDateTime } from "@/util"

//import { useRouter } from "vue-router"


const part = partnerStore()
const route = useRoute()

const isSidebarCollapsed = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)
const loading = ref(true)
const defaultImage = avatarImage
const partnerId = route.params.id

/* Mobile */
const toggleSidebar = () => {
  if (isMobile.value) drawerOpen.value = !drawerOpen.value
  else isSidebarCollapsed.value = !isSidebarCollapsed.value
}

const checkMobile = () => {
  isMobile.value = window.innerWidth < 768
  drawerOpen.value = !isMobile.value
}

const partner = computed(() => {
  return part.singlePartner?.[0] || null
})



/* Lifecycle */
onMounted(async () => {
  checkMobile()
  window.addEventListener("resize", checkMobile)
  await part.loadSinglePartner(partnerId)
  //console.log('User investments:', investmentTransactions.value) // Debug log
  loading.value = false
})

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile)
})

</script>

<style scoped>
.main {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  background: #f8fafc;
}

/* Card */
.table-card {
  padding: 20px;
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}

/* Header */
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Table */
.modern-table {
  border: none;
}

/* Product */
.product-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.product-image {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
}

.product-name {
  font-weight: 700;
}

.product-desc {
  font-size: 16px;
  color: #64748b;
}

/* Status */
.status-pill {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.status-active {
  background: #ecfdf5;
  color: #2ba316;
}

.status-inactive {
  background: #fef2f2;
  color: #dc2626;
}

.status-ongoing {
  background: #d6a11b;
  color: #f2f4f2;
}

.status-completed {
  background: #ecfdf5;
  color: #2ba316;
}

.title-separator {
  border: none;
  border-top: 1px solid #eae4e4;
  margin: 12px 0;
}

/* Button */
.theme-button {
  height: 46px;
  background: #000;
  color: #fff;
  border-radius: 10px;
  font-weight: 600;
  transition: all 0.25s ease;
}

/* Inner cards */
.inner-card {
  border: 1px solid #eae5e5;
  border-radius: 6px;
  padding: 8px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.inner-mini-card {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #ffffff;
}

.long-tab {
  text-transform: none;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.3px;
}

:deep(.v-tab) {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-right: 8px;
}

:deep(.v-tab.v-tab--selected) {
  background: #025227;
  color: #fff;
}

/* Table */
.modern-table {
  border: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

:deep(.modern-table .p-datatable-thead > tr > th) {
  background: #eef7f0;
  color: #065f46;
  font-weight: 600;
  border-bottom: 2px solid #c1edc3;
}

.p-datatable-tbody > tr {
  cursor: pointer;
}

.p-datatable-tbody > tr:hover {
  background-color: #f5f5f5;
}
</style>
